import React, { useEffect, useState } from "react"
// MUI
import {Button, Grid, TextField } from "@mui/material"
import DownloadIcon from '@mui/icons-material/Download'
// style
import {style} from "./style"
// API
import { APIGetBlobCustomHeader } from "../../api/apiCalls"
import {returnQRCodeParameters} from "../../utils/parsingFunctions";
import {downloadBlob} from "../../utils/fileFunctions";

export default function QRCodeMedia(props: any) {

    const {fieldDisplay} = props
    const {allow_download, password} = fieldDisplay;
    
    const [mediaSrc, setMediaSrc] = useState<any>(null);
    const [contentType, setContentType] = useState<string>("")
    const [download, setDownload] = useState<boolean>(false);
    const [pwd, setPwd] = useState<string>("");

    const {resAddr, type, id} = returnQRCodeParameters()

    useEffect(() => {
        downloadContent();
        if (allow_download) setDownload(allow_download);
    }, [fieldDisplay])

    const handleChange = (event: any) => {
        setPwd(event.target.value)
    }

    const downloadContent = () => {
        const headers: Record<string, string> = {
            "X-Media-Password": pwd
        }

        console.log("download content routine")
        APIGetBlobCustomHeader(`${resAddr}/${type}/${id}/download`, headers)
        .then((data: any) => {
            console.log("get blob custom header// media", resAddr, type, id)
            if (data.ok && data.rawBlob) {
                setContentType(data.rawBlob.type)
                let blob: any = data.rawBlob;
                if (data.rawBlob.type === 'audio/mpeg') {
                    blob = new Blob([blob], { type: data.rawBlob.type })
                }
                setMediaSrc(blob);
            }
        })
        .catch((err: Error) => {
            console.log(err);
        })
    }

    const playAudio = () => {
        if (mediaSrc === null) return null;

        return (
            <audio id="audio-player" controls>
                <source src={window.URL.createObjectURL(mediaSrc)}/>
            </audio>
        )
    }

    const playVideo = () => {
        if (mediaSrc === null) return null;

        return (
            <video id="player" autoPlay controls controlsList="nodownload" width="100%">
                <source src={window.URL.createObjectURL(mediaSrc)}/>
            </video>
        )
    }

    return (
        <Grid item container md={12} justifyContent={'center'} justifyItems={'center'}>
            {password && mediaSrc === null ?
                <>
                    <Grid container md={12}>
                        <TextField
                            id="password"
                            label="Password"
                            type="password"
                            sx={style.textField}
                            value={pwd}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid container md={12} >
                        <Button 
                            onClick={downloadContent}
                            variant="contained"
                            fullWidth
                        >
                            Ask Permission
                        </Button>
                    </Grid>
                </>
            :
                <>
                    {
                        contentType === 'audio/mpeg'
                            ? playAudio()
                            : playVideo()
                    }

                    { download &&
                        <Button
                            variant={'contained'}
                            sx={style.button2}
                            onClick={() => {downloadBlob(`${id}`, mediaSrc)}}
                        >
                            <DownloadIcon style={style.icon}/> Download
                        </Button>
                    }
                </>
            }
        </Grid>
    );
}
